module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "Risks.59f3bba1.svg";